import { Component, ViewEncapsulation, OnInit, ViewChild } from "@angular/core";
import { ControlCrane } from "../../services/controlCrane.service";
import { Router } from "@angular/router";
import { EJComponents } from "ej-angular2/src/ej/core";
import { AppStateService } from "../../services/appState.service";
import { ImageAngleFromCenterComponent } from "../ImageAngleFromCenter/ImageAngleFromCenter.component";

import { ControlAllgemeinComponent } from "../craneControlAllgemein/controlAllgemein.component";
import { CapacityChartComponent } from "./capacityChart.component";

import * as allgemeineFunktionen from "../../allgemeinesTS_CSS/allgemeineHilfsfunktionen";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-crane-control",
  templateUrl: "./controlMaxBase.component.html",
  styleUrls: [
    "../craneControlAllgemein/controlAllgemein.component.css",
    "../../allgemeinesTS_CSS/tooltip.css",
    "../../allgemeinesTS_CSS/cssButton.css",
    "./controlMaxBase.component.css",
  ],
  providers: [ControlCrane],
})
export class ControlMaxBaseComponent
  extends ControlAllgemeinComponent
  implements OnInit
{
  //  @ViewChild('LastGraph') LastGraph: any;
  @ViewChild(CapacityChartComponent)
  private LastGraph: CapacityChartComponent;
  public rotate = "rotate(0deg)";
  private lastTabelleAktualisieren = false;
  public drehbereichGrafik = "";
  public drehbereichGrafikTransparent = "deps/images/transparent100px.png";

  // private ChartDaten: object = {};

  constructor(
    private craneControlService: ControlCrane,
    private router: Router,
    private appStateService: AppStateService,
    private sanitizer: DomSanitizer
  ) {
    super(craneControlService, router, appStateService, sanitizer);
  }
  ngOnInit() {
    this.sichtbarkeitUmruestung = 0.5;
    this.appStateService.appStatusVonServerHolen().then((res) => {
      if (res["loginStatus"] !== "loggedIn") {
        this.router.navigate(["/"]);
      }
      this.appStateService.appStatusSetzen({
        aktuellerMenuePunkt: "CraneControl",
        PrintOut: "active",
      });
      this.gewichtsEinheit = this.appStateService.holeEinheitenSystem("G");
      this.laengenEinheit = this.appStateService.holeEinheitenSystem("L");
      this.initComponent();
    });
  }
  initComponent() {
    let kranAbstuetzung =
      this.appStateService.aktuellerAppStatus["abstuetzMuster"];
    kranAbstuetzung = kranAbstuetzung === undefined ? "5555" : kranAbstuetzung;
    this.stuetzeHR =
      this.grafikBasis +
      "Stuetzen_L_" +
      kranAbstuetzung.substring(3, 4) +
      "-" +
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"] +
      ".png";
    this.stuetzeHL =
      this.grafikBasis +
      "Stuetzen_R_" +
      kranAbstuetzung.substring(2, 3) +
      "-" +
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"] +
      ".png";
    this.stuetzeVR =
      this.grafikBasis +
      "Stuetzen_L_" +
      kranAbstuetzung.substring(1, 2) +
      "-" +
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"] +
      ".png";
    this.stuetzeVL =
      this.grafikBasis +
      "Stuetzen_R_" +
      kranAbstuetzung.substring(0, 1) +
      "-" +
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"] +
      ".png";
    if (
      this.appStateService.aktuellerAppStatus["abstuetzProzenteVL"] !==
      undefined
    ) {
      this.abstuetzungProzent["stuetzeVL"] =
        this.appStateService.aktuellerAppStatus["abstuetzProzenteVL"];
    } else {
      this.abstuetzungProzent["stuetzeVL"] = "0";
    }
    if (
      this.appStateService.aktuellerAppStatus["abstuetzProzenteVR"] !==
      undefined
    ) {
      this.abstuetzungProzent["stuetzeVR"] =
        this.appStateService.aktuellerAppStatus["abstuetzProzenteVR"];
    } else {
      this.abstuetzungProzent["stuetzeVR"] = "0";
    }

    if (
      this.appStateService.aktuellerAppStatus["abstuetzProzenteHL"] !==
      undefined
    ) {
      this.abstuetzungProzent["stuetzeHL"] =
        this.appStateService.aktuellerAppStatus["abstuetzProzenteHL"];
    } else {
      this.abstuetzungProzent["stuetzeHL"] = "0";
    }
    if (
      this.appStateService.aktuellerAppStatus["abstuetzProzenteHR"] !==
      undefined
    ) {
      this.abstuetzungProzent["stuetzeHR"] =
        this.appStateService.aktuellerAppStatus["abstuetzProzenteHR"];
    } else {
      this.abstuetzungProzent["stuetzeHR"] = "0";
    }
    super.initComponent();
  }
  holeInitialeDaten() {
    if (this.aendereWerte["holeInitialeDaten"] !== undefined) {
      clearTimeout(this.aendereWerte["holeInitialeDaten"]);
    }
    this.aendereWerte["holeInitialeDaten"] = setTimeout(() => {
      if (this.lastGesetzt === true) {
        this.aktualisiereAnzeige = true;
        this.craneControlService.minMAXan(true).then(() => {
          this.aktualisiereAnzeige = false;
          this.holeRuestdaten();
          this.holeErgebnisse();
          this.holeLastTabellen();
          this.holeAktivenBereich(true);
          this.drehbereichGrafik =
            "LiftplanII/Kransteuerung/kranSteuerung.php?action=erzeugeDrehbereichGrafik&tag=" +
            new Date().getTime();
          this.initialisiereKran = false;
          super.holeInitialeDaten();
          //            this.pruefeAufKompatiblenTabellenKran();
        });
      } else {
        this.holeInitialeDaten();
      }
    }, 200);
  }
  holeLastTabellen() {
    this.lastTabelleAktualisieren = true;
    this.craneControlService.holeLastTabellen().then((res) => {
      this.einlesenLastTabellen(res);
    });
  }
  einlesenRuestdaten(res) {
    super.einlesenRuestdaten(res);
    this.rotate = "rotate(" + res["OWWinkel"] + "deg)";
  }
  einlesenLastTabellen(res) {
    this.LastGraph.LastChart.widget.model.series[0].dataSource =
      res["nachVorne"];
    this.LastGraph.LastChart.widget.model.series[1].dataSource =
      res["nachHinten"];
    this.LastGraph.LastChart.widget.model.series[2].dataSource =
      res["nachLinks"];
    this.LastGraph.LastChart.widget.model.series[3].dataSource =
      res["nachRechts"];
    // Workaround für Syncfusion Bug!
    this.LastGraph.LastChart.widget.model.commonSeriesOptions.dataSource = [];
    this.LastGraph.LastChart.widget.redraw();
    this.lastTabelleAktualisieren = false;
  }
  haLaengeAendernAusfuehren(): Promise<any> {
    return super
      .haLaengeAendernAusfuehren()
      .then(() => this.holeLastTabellen());
  }
  owWinkelAendern(e = "") {
    if (typeof e === "number") {
      e = String(allgemeineFunktionen.rundeZahl(e, 2));
      e = String(e);
    }
    this.owWinkelGesetzt = false;
    super.owWinkelAendern(e);
    this.holeAktivenBereich(false);
  }
  holeAktivenBereich(clear = false) {
    if (this.aendereWerte["aktivenBereichHolen"] !== undefined) {
      clearTimeout(this.aendereWerte["aktivenBereichHolen"]);
    }
    this.aendereWerte["aktivenBereichHolen"] = setTimeout(() => {
      if (this.owWinkelGesetzt === true) {
        this.craneControlService
          .holeAktivenBereich(this.OWWinkel)
          .then((res) => {
            switch (res["sichtbarerBereich"]) {
              case "vorne":
                this.LastGraph.LastChart.widget.model.series[0].visibility =
                  "visible";
                break;
              case "hinten":
                this.LastGraph.LastChart.widget.model.series[1].visibility =
                  "visible";
                break;
              case "links":
                this.LastGraph.LastChart.widget.model.series[2].visibility =
                  "visible";
                break;
              case "rechts":
                this.LastGraph.LastChart.widget.model.series[3].visibility =
                  "visible";
                break;
              case "rundum":
              default:
                this.LastGraph.LastChart.widget.model.series[0].visibility =
                  "visible";
                this.LastGraph.LastChart.widget.model.series[1].visibility =
                  "visible";
                this.LastGraph.LastChart.widget.model.series[2].visibility =
                  "visible";
                this.LastGraph.LastChart.widget.model.series[3].visibility =
                  "visible";
            }
            if (clear === true) {
              switch (res["sichtbarerBereich"]) {
                case "vorne":
                  this.LastGraph.LastChart.widget.model.series[1].visibility =
                    "hidden";
                  this.LastGraph.LastChart.widget.model.series[2].visibility =
                    "hidden";
                  this.LastGraph.LastChart.widget.model.series[3].visibility =
                    "hidden";
                  break;
                case "hinten":
                  this.LastGraph.LastChart.widget.model.series[0].visibility =
                    "hidden";
                  this.LastGraph.LastChart.widget.model.series[2].visibility =
                    "hidden";
                  this.LastGraph.LastChart.widget.model.series[3].visibility =
                    "hidden";
                  break;
                case "links":
                  this.LastGraph.LastChart.widget.model.series[0].visibility =
                    "hidden";
                  this.LastGraph.LastChart.widget.model.series[1].visibility =
                    "hidden";
                  this.LastGraph.LastChart.widget.model.series[3].visibility =
                    "hidden";
                  break;
                case "rechts":
                  this.LastGraph.LastChart.widget.model.series[0].visibility =
                    "hidden";
                  this.LastGraph.LastChart.widget.model.series[1].visibility =
                    "hidden";
                  this.LastGraph.LastChart.widget.model.series[2].visibility =
                    "hidden";
                  break;
                default:
                  break;
              }
            }
            this.LastGraph.LastChart.widget.redraw();
            this.appStateService.appStatusSetzen({
              GraphVorne:
                this.LastGraph.LastChart.widget.model.series[0].visibility,
              GraphHinten:
                this.LastGraph.LastChart.widget.model.series[1].visibility,
              GraphLinks:
                this.LastGraph.LastChart.widget.model.series[2].visibility,
              GraphRechts:
                this.LastGraph.LastChart.widget.model.series[3].visibility,
            });
          });
      } else {
        this.holeAktivenBereich(clear);
      }
    }, 100);
  }
  aendereSerienSichtbarkeit(event) {
    const sichtbarkeit = event;
    this.appStateService.appStatusSetzen({
      GraphVorne: sichtbarkeit[0],
      GraphHinten: sichtbarkeit[1],
      GraphLinks: sichtbarkeit[2],
      GraphRechts: sichtbarkeit[3],
    });
  }

  bitteWarten() {
    return super.bitteWarten() || this.lastTabelleAktualisieren;
  }
  gibStatus() {
    if (
      allgemeineFunktionen.isset(this.appStateService) &&
      allgemeineFunktionen.isset(this.appStateService.aktuellerAppStatus) &&
      allgemeineFunktionen.isset(
        this.appStateService.aktuellerAppStatus["pointer"]
      )
    ) {
      return this.appStateService.aktuellerAppStatus["pointer"];
    } else {
      return "nix";
    }
  }
}
